import { useReduxState } from 'hooks';
import { getAttributesWithMergedOptions } from 'shared-helpers/customAttributes';
import { BoxTableCell } from 'components/common/box';
import { UserCustomAttributeDisplayValue } from 'components/common/customAttributes';

import type { RequestUser } from 'shared-types';
import type { PageState } from 'types';

interface Props {
  loggedInUser: RequestUser;
  returnPart: 'header' | 'body';
  user?: PageState['user'];
}

const UsersViewAttributes = ({ loggedInUser, returnPart, user }: Props) => {
  const {
    language,
    serverConfig: { userCustomAttributes }
  } = useReduxState();

  const viewableUserCustomAttributes = getAttributesWithMergedOptions({
    language,
    onlyViewable: true,
    requestUser: loggedInUser,
    userCustomAttributes
  });

  return returnPart === 'header' ? (
    <>
      {viewableUserCustomAttributes.map((attribute) => (
        <BoxTableCell key={attribute.key}>
          {attribute.titleTranslations?.[language] || attribute.title}
        </BoxTableCell>
      ))}
    </>
  ) : returnPart === 'body' && user ? (
    <>
      {viewableUserCustomAttributes.map((attribute) => (
        <BoxTableCell
          key={attribute.key}
          label={attribute.titleTranslations?.[language] || attribute.title}
        >
          <UserCustomAttributeDisplayValue
            attribute={attribute}
            value={user.customAttributes[attribute.key]}
          />
        </BoxTableCell>
      ))}
    </>
  ) : null;
};

export default UsersViewAttributes;
